import SpinningCircle from './SpinningCircle'
import SpinningDots from './SpinningDots'

export { SpinningCircle, SpinningDots }
